export default __webpack_public_path__ + "static/media/active-alert.a06ec0ec.svg";